import { Table } from "soprasteria-ui-library";
import * as React from "react";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { IOrthodonticLkgCfPatient } from "../../../../models/IOrthodonticLkgCfPatient";

interface IOrthodonticLkgCfPatientsTab {
    orthodonticLkgCfPatients: IOrthodonticLkgCfPatient[];
}

export const OrthodonticLkgCfPatientsTab: React.FunctionComponent<IOrthodonticLkgCfPatientsTab> = ({ orthodonticLkgCfPatients }) => {
    return (
        <Table>
            <thead>
                <tr>
                    <th>Mottagning</th>
                    <th>Startdatum</th>
                    <th>Slutdatum</th>
                    <th>Typ</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticLkgCfPatients && orthodonticLkgCfPatients.length > 0 ?
                        orthodonticLkgCfPatients.map((orthodonticLkgCfPatient, key) =>
                            <tr key={key}>
                                <td>{orthodonticLkgCfPatient.careProvider?.displayCareProviderName}</td>
                                <td>{dateTimeToDateString(orthodonticLkgCfPatient.lkgCfStartedDate)}</td>
                                <td>{dateTimeToDateString(orthodonticLkgCfPatient.lkgCfEndedDate)}</td>
                                <td>{orthodonticLkgCfPatient.orthodonticLkgCfPatientType}</td>
                                <td>{orthodonticLkgCfPatient.orthodonticLkgCfPatientStatus}</td>
                            </tr>
                        )
                        : <tr><td colSpan={5}>Hittade inga LKG/CF-registreringar</td></tr>
                }
            </tbody>
        </Table>
    )
}